module.exports = __webpack_public_path__ + "static/media/illustrator.93ceeb6a.svg";